module.exports = __webpack_public_path__ + "static/media/png_icon.f1ae6187.svg";